<ngb-toast *ngFor="let toast of notificationService.toasts"
           [autohide]="toast.delay > 0"
           [delay]="toast.delay"
           (hide)="notificationService.remove(toast)"
           [class]="toast.className"
           class="toast">

  <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
    <ng-template [ngTemplateOutlet]="toast.body"></ng-template>
  </ng-template>

  <ng-template #text>{{ toast.body }}</ng-template>
</ngb-toast>
